import { render, staticRenderFns } from "./phceshi.vue?vue&type=template&id=b3f76a08"
import script from "./phceshi.vue?vue&type=script&lang=js"
export * from "./phceshi.vue?vue&type=script&lang=js"
import style0 from "./phceshi.vue?vue&type=style&index=0&id=b3f76a08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports